// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"237":"job-offers-details","719":"unsubscribe","976":"job-offers"}[chunkId] + "-legacy." + {"237":"4c9b14fc","719":"fc8c0191","976":"428c4d40"}[chunkId] + ".js";
};